<template>
    <div class="page page__list">
      <div class="nav">
        <span
          :class="selected == '会议管理' ? 'selected' : ''"
          @click="toggle('会议管理')"
          >会议管理</span
        >
        <span>|</span>
        <span
          :class="selected == '会议模板' ? 'selected' : ''"
          @click="toggle('会议模板')"
          >会议模板</span
        >
      </div>
  
      <div v-show="selected == '会议管理'">
       <meeting-list ref="meetingList"></meeting-list>
      </div>
  
      <div v-show="selected == '会议模板'">
        <meeting-template-list ref="meetingTemplateList"></meeting-template-list>
      </div>
    </div>
  </template>

<script>
import MeetingList from './MeetingList.vue';
import MeetingTemplateList from './MeetingTemplateList.vue';

export default {
  components: {
    MeetingList,
    MeetingTemplateList,
  },
  data() {
    return {
      selected: "会议管理",
    };
  },

  mounted() {
    this.$refs.meetingList.search();
  },
  methods: {
    toggle(val) {
      this.selected = val;
      if(val == '会议管理'){
        this.$refs.meetingList.search();
      }else{
        this.$refs.meetingTemplateList.search();
      }
    },
  },
}
</script>


<style scoped>
.bg-color {
  background: #d1e9fe;
}
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected {
  color: #38559f;
}

</style>